/* =====================================================
   SHIFT CULTURE PERFORMANCE — SCRIPT.JS
   ===================================================== */

'use strict';

/* =====================================================
   VEHICLE DATA
   ===================================================== */
const vehicleData = {
  'Acura': { models: ['Integra', 'Integra Type S', 'TLX', 'TLX Type S', 'NSX'], years: '2002-2026' },
  'Audi': { models: ['A4 / S4', 'A5 / S5', 'A6 / S6', 'A7 / S7', 'RS3', 'RS5', 'RS6', 'RS7', 'TT / TTS / TTRS', 'R8 V10'], years: '2008-2026' },
  'BMW': { models: ['M2 / M2 Comp', 'M3 / M3 Comp', 'M4 / M4 Comp', 'M5 / M5 Comp', 'M8 / M8 Comp', '335i / 340i / M340i', '435i / 440i / M440i', '535i / 540i / M550i', 'X3 M / X4 M', 'X5 M / X6 M'], years: '2006-2026' },
  'Chevrolet': { models: ['Camaro SS', 'Camaro ZL1', 'Camaro Z/28', 'Corvette C7', 'Corvette C8'], years: '2010-2026' },
  'Ferrari': { models: ['488 GTB', '488 Pista', 'F8 Tributo', 'F8 Spider', '296 GTB', 'SF90 Stradale', 'Roma', 'Portofino M'], years: '2015-2026' },
  'Ford': { models: ['Mustang GT', 'Mustang EcoBoost', 'Mustang Mach 1', 'Mustang Dark Horse', 'Focus RS', 'Focus ST', 'Fiesta ST'], years: '2013-2026' },
  'Honda': { models: ['Civic Si', 'Civic Type R (FK8)', 'Civic Type R (FL5)', 'Accord 2.0T', 'S2000'], years: '2000-2026' },
  'Hyundai': { models: ['Genesis Coupe', 'Elantra N', 'Veloster N', 'Kona N'], years: '2010-2026' },
  'Lamborghini': { models: ['Huracan Evo', 'Huracan STO', 'Huracan Tecnica', 'Huracan Performante', 'Urus', 'Urus Performante', 'Aventador', 'Aventador SVJ'], years: '2014-2026' },
  'Lexus': { models: ['IS-F', 'IS350 F-Sport', 'RC-F', 'GS-F', 'LC500'], years: '2008-2026' },
  'Mazda': { models: ['MX-5 Miata (NC)', 'MX-5 Miata (ND)', 'Mazdaspeed3', 'Mazdaspeed6'], years: '2006-2026' },
  'McLaren': { models: ['570S', '600LT', '720S', '765LT', 'Artura', 'GT', '600S'], years: '2016-2026' },
  'Mercedes-AMG': { models: ['C63 / C63 S', 'E63 / E63 S', 'GT 63 S', 'GT R / Black Series', 'A45 / CLA45', 'G63'], years: '2014-2026' },
  'Mitsubishi': { models: ['Lancer Evolution VIII', 'Lancer Evolution IX', 'Lancer Evolution X'], years: '2003-2015' },
  'Nissan': { models: ['350Z', '370Z', 'Z (RZ34)', 'GT-R R35 Premium', 'GT-R R35 Nismo', 'GT-R R35 Track Edition'], years: '2003-2026' },
  'Porsche': { models: ['911 Carrera', '911 Turbo / Turbo S', '911 GT3 / GT3 RS', '911 GT2 RS', '718 Cayman / Boxster', '718 GT4 / Spyder', 'Macan', 'Cayenne', 'Panamera'], years: '2014-2026' },
  'Subaru': { models: ['WRX', 'WRX STI', 'BRZ'], years: '2008-2026' },
  'Toyota': { models: ['Supra Mk4 (A80)', 'Supra A90', 'GR Corolla', 'GR86', '86', 'Camry TRD'], years: '1993-2026' },
  'Volkswagen': { models: ['Golf GTI Mk6', 'Golf GTI Mk7', 'Golf GTI Mk8', 'Golf R Mk6', 'Golf R Mk7', 'Golf R Mk8', 'Jetta GLI'], years: '2010-2026' }
};

/* =====================================================
   UTILITY BAR ROTATOR
   ===================================================== */
function initUtilityRotator() {
  const items = document.querySelectorAll('.utility-rotator__item');
  if (!items.length) return;

  let current = 0;

  setInterval(() => {
    items[current].classList.remove('active');
    current = (current + 1) % items.length;
    items[current].classList.add('active');
  }, 4000);
}

/* =====================================================
   NAV SCROLL STATE
   ===================================================== */
function initNavScroll() {
  const nav = document.getElementById('siteNav');
  if (!nav) return;

  const onScroll = () => {
    if (window.scrollY > 20) {
      nav.classList.add('scrolled');
    } else {
      nav.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* =====================================================
   MOBILE HAMBURGER / DRAWER
   ===================================================== */
function initMobileMenu() {
  const hamburger = document.getElementById('hamburger');
  const drawer = document.getElementById('mobileDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const closeBtn = document.getElementById('drawerClose');

  if (!hamburger || !drawer) return;

  const open = () => {
    hamburger.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    hamburger.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  hamburger.addEventListener('click', () => {
    if (drawer.classList.contains('open')) close();
    else open();
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });
}

/* =====================================================
   HERO LOAD ANIMATIONS
   ===================================================== */
function initHeroAnimations() {
  const headline = document.getElementById('heroHeadline');
  if (!headline) return;

  // Read text from data-headline attribute (Shopify-driven), fallback to default
  const text = headline.dataset.headline || 'ENGINEERED FOR THE UNCOMPROMISING.';
  const charWrap = headline.querySelector('.char-wrap');
  if (!charWrap) return;
  charWrap.innerHTML = '';

  // Group by word so the line wraps between words, not mid-word.
  // Each word is an inline-block span; chars inside it animate individually.
  let delay = 0;
  const words = text.split(/(\s+)/); // keep whitespace tokens
  words.forEach((token) => {
    if (/^\s+$/.test(token)) {
      // Render whitespace as a real text node — gives the browser a break opportunity.
      charWrap.appendChild(document.createTextNode(' '));
      return;
    }
    const wordSpan = document.createElement('span');
    wordSpan.className = 'word';
    wordSpan.style.display = 'inline-block';
    token.split('').forEach((char) => {
      const span = document.createElement('span');
      span.className = 'char';
      span.textContent = char;
      span.style.transitionDelay = `${delay}ms`;
      wordSpan.appendChild(span);
      delay += 28;
    });
    charWrap.appendChild(wordSpan);
  });

  // Trigger on load
  requestAnimationFrame(() => {
    document.body.classList.add('loaded');
    const chars = headline.querySelectorAll('.char');
    setTimeout(() => {
      chars.forEach(c => c.classList.add('revealed'));
    }, 80);
  });
}

/* =====================================================
   SCROLL REVEAL — IntersectionObserver
   ===================================================== */
function initScrollReveal() {
  const elements = document.querySelectorAll('.reveal');
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -48px 0px',
    }
  );

  elements.forEach((el) => observer.observe(el));
}

/* =====================================================
   FITMENT / VEHICLE SELECTOR
   ===================================================== */
function initFitmentSelector() {
  const yearSelect = document.getElementById('yearSelect');
  const makeSelect = document.getElementById('makeSelect');
  const modelSelect = document.getElementById('modelSelect');
  const fitmentCta = document.getElementById('fitmentCta');
  const chips = document.querySelectorAll('.chip');

  // Populate years
  if (yearSelect) {
    for (let y = 2026; y >= 2014; y--) {
      const opt = document.createElement('option');
      opt.value = y;
      opt.textContent = y;
      yearSelect.appendChild(opt);
    }
  }

  const updateCtaState = () => {
    if (!fitmentCta) return;
    const filled = yearSelect?.value && makeSelect?.value && modelSelect?.value;
    if (filled) {
      fitmentCta.classList.add('pulsing');
    } else {
      fitmentCta.classList.remove('pulsing');
    }
  };

  // Make → populate model
  if (makeSelect && modelSelect) {
    makeSelect.addEventListener('change', () => {
      const make = makeSelect.value;
      modelSelect.innerHTML = '';
      modelSelect.disabled = !make;

      if (!make) {
        const opt = document.createElement('option');
        opt.value = '';
        opt.textContent = 'SELECT MAKE FIRST';
        modelSelect.appendChild(opt);
        updateCtaState();
        return;
      }

      const defaultOpt = document.createElement('option');
      defaultOpt.value = '';
      defaultOpt.textContent = 'SELECT MODEL';
      modelSelect.appendChild(defaultOpt);

      const data = vehicleData[make];
      if (data) {
        data.models.forEach((model) => {
          const opt = document.createElement('option');
          opt.value = model;
          opt.textContent = model;
          modelSelect.appendChild(opt);
        });
      }

      updateCtaState();
    });

    modelSelect.addEventListener('change', updateCtaState);
  }

  if (yearSelect) yearSelect.addEventListener('change', updateCtaState);

  // Quick-select chips
  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');

      const make = chip.dataset.make;
      const model = chip.dataset.model;

      if (makeSelect && make) {
        makeSelect.value = make;
        makeSelect.dispatchEvent(new Event('change'));
      }

      // Wait for model options to populate
      setTimeout(() => {
        if (modelSelect && model) {
          modelSelect.value = model;
          modelSelect.dispatchEvent(new Event('change'));
        }

        if (yearSelect) {
          const data = vehicleData[make];
          if (data) {
            const maxYear = parseInt(data.years.split('-')[1]) || 2026;
            yearSelect.value = Math.min(maxYear, 2026);
            yearSelect.dispatchEvent(new Event('change'));
          }
        }
      }, 50);

      // Scroll to fitment section
      document.getElementById('fitment')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

/* =====================================================
   DRAG-TO-SCROLL CAROUSELS
   ===================================================== */
function initDragScroll(selector) {
  const carousels = document.querySelectorAll(selector);

  carousels.forEach((carousel) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    carousel.addEventListener('mousedown', (e) => {
      isDown = true;
      carousel.classList.add('dragging');
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('mouseleave', () => {
      isDown = false;
      carousel.classList.remove('dragging');
    });

    carousel.addEventListener('mouseup', () => {
      isDown = false;
      carousel.classList.remove('dragging');
    });

    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 1.5;
      carousel.scrollLeft = scrollLeft - walk;
    });

    // Touch events handled natively by overflow-x: auto
  });
}

/* =====================================================
   CAROUSEL NAV — arrow buttons under each carousel.
   Wires [data-carousel-prev] / [data-carousel-next] inside a
   [data-carousel-shell] to scroll the [data-carousel] element
   inside that shell by one card width per click.
   Also updates [data-carousel-progress] with "n / total" indicator
   and disables buttons at the start/end of the scroll range.
   ===================================================== */
function initCarouselNav() {
  const shells = document.querySelectorAll('[data-carousel-shell]');

  shells.forEach((shell) => {
    const carousel = shell.querySelector('[data-carousel]');
    const prev = shell.querySelector('[data-carousel-prev]');
    const next = shell.querySelector('[data-carousel-next]');
    const progress = shell.querySelector('[data-carousel-progress]');
    if (!carousel || !prev || !next) return;

    const getCardWidth = () => {
      const firstCard = carousel.children[0];
      if (!firstCard) return 0;
      const cardRect = firstCard.getBoundingClientRect();
      const styles = getComputedStyle(carousel);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return cardRect.width + gap;
    };

    const getCardsVisible = () => {
      const styles = getComputedStyle(carousel);
      const cardsVar = styles.getPropertyValue('--carousel-cards').trim();
      const n = parseInt(cardsVar, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    };

    const updateNav = () => {
      const max = carousel.scrollWidth - carousel.clientWidth;
      prev.disabled = carousel.scrollLeft <= 1;
      next.disabled = carousel.scrollLeft >= max - 1;

      if (progress) {
        const total = carousel.children.length;
        const visible = getCardsVisible();
        const cardW = getCardWidth();
        const pages = Math.max(1, Math.ceil((total - visible + 1)));
        const currentPage = cardW > 0
          ? Math.min(pages, Math.round(carousel.scrollLeft / cardW) + 1)
          : 1;
        progress.textContent = `${currentPage} / ${total}`;
      }
    };

    prev.addEventListener('click', () => {
      carousel.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      carousel.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
    });

    let scrollTimer;
    carousel.addEventListener('scroll', () => {
      // Throttle scroll updates so we don't thrash on every pixel
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(updateNav);
    }, { passive: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateNav, 150);
    });

    updateNav();
  });
}

/* =====================================================
   NEWSLETTER FORM
   ===================================================== */
function initNewsletter() {
  const form = document.getElementById('newsletterForm');
  if (!form) return;

  const publicKey = form.dataset.klaviyoPublicKey;
  const listId = form.dataset.klaviyoListId;
  const source = form.dataset.klaviyoSource || 'Newsletter';
  if (!publicKey || !listId) {
    console.warn('[newsletter] Klaviyo public key or list ID missing — form will not submit');
    return;
  }

  const input = form.querySelector('.newsletter-input');
  const btn = form.querySelector('.btn');
  const msg = form.querySelector('[data-newsletter-msg]');
  if (!input || !btn) return;

  function setMsg(text, color) {
    if (!msg) return;
    msg.textContent = text;
    msg.style.color = color || '';
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = (input.value || '').trim();
    if (!email) return;

    const originalText = btn.textContent;
    btn.textContent = 'SUBSCRIBING…';
    btn.disabled = true;
    setMsg('', '');

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
            },
          },
        },
        relationships: {
          list: {
            data: { type: 'list', id: listId },
          },
        },
      },
    };

    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15',
          },
          body: JSON.stringify(payload),
        }
      );
      // Klaviyo returns 202 Accepted on success (no body)
      if (res.status === 202 || res.ok) {
        btn.textContent = 'SUBSCRIBED ✓';
        btn.style.background = '#2a7a2a';
        input.value = '';
        setMsg('You\'re on the list. Watch for new drops.', 'var(--gold)');
        try { pushDataLayer && pushDataLayer('newsletter_subscribe', { email: email, list_id: listId }); } catch (e) {}
      } else {
        const text = await res.text().catch(() => '');
        let userMessage = 'Something went wrong — please try again.';
        // 400 with already-subscribed is still a "success" UX-wise
        if (text && /already.{0,10}subscribed|already.{0,10}exists/i.test(text)) {
          btn.textContent = 'ALREADY SUBSCRIBED';
          btn.style.background = '#2a7a2a';
          input.value = '';
          setMsg('You\'re already on the list.', 'var(--gold)');
          return;
        }
        console.warn('[newsletter] Klaviyo subscribe failed:', res.status, text);
        setMsg(userMessage, 'var(--red, #c33)');
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }
    } catch (err) {
      console.error('[newsletter] Network error:', err);
      setMsg('Network error — please try again.', 'var(--red, #c33)');
      btn.textContent = originalText;
      btn.style.background = '';
      btn.disabled = false;
      return;
    }

    // Reset visual after a few seconds
    setTimeout(() => {
      btn.textContent = originalText;
      btn.style.background = '';
      btn.disabled = false;
    }, 5000);
  });
}

/* =====================================================
   PDP: TABS
   ===================================================== */
function initPdpTabs() {
  const tabBtns = document.querySelectorAll('.pdp-tab-btn');
  const tabPanels = document.querySelectorAll('.pdp-tab-panel');
  if (!tabBtns.length) return;

  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;

      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));

      btn.classList.add('active');
      const panel = document.getElementById(`tab-${target}`);
      if (panel) panel.classList.add('active');
    });
  });
}

/* =====================================================
   PDP: GALLERY THUMBNAILS
   ===================================================== */
function initPdpGallery() {
  const mainImg = document.getElementById('pdpMainImg');
  const thumbs = document.querySelectorAll('.pdp-thumb');
  if (!mainImg || !thumbs.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      // Prefer data-src (full-size url) over thumbnail's own src
      const src = thumb.dataset.src || thumb.querySelector('img')?.src;
      if (src) {
        mainImg.style.transition = 'opacity 0.2s';
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 200);
      }
    });
  });
}

/* =====================================================
   PDP: OPTION SELECTORS + VARIANT MATCHING
   ===================================================== */
function initPdpOptions() {
  const productJsonEl = document.querySelector('[data-product-json]');
  const variantSelect = document.querySelector('[data-variant-select]');
  const optionGroups = document.querySelectorAll('.pdp-option-btns');
  const priceDisplay = document.querySelector('[data-price-display]');
  const priceMain = document.getElementById('pdpPrice');
  const addBtn = document.querySelector('.pdp-add-btn');

  if (!optionGroups.length) return;

  let productData = null;
  if (productJsonEl) {
    try { productData = JSON.parse(productJsonEl.textContent); } catch (e) { /* swallow */ }
  }

  const formatMoney = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
  };

  const findVariant = () => {
    if (!productData) return null;
    const selected = [];
    optionGroups.forEach((g) => {
      const active = g.querySelector('.pdp-option-btn.active');
      if (active) selected.push(active.dataset.optionValue);
    });
    return productData.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );
  };

  const updateForVariant = (variant) => {
    if (!variant) return;
    if (variantSelect) variantSelect.value = variant.id;
    if (priceMain) priceMain.textContent = formatMoney(variant.price);
    if (priceDisplay) priceDisplay.textContent = formatMoney(variant.price);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (!variant.available) {
        addBtn.textContent = 'SOLD OUT';
      }
    }
  };

  optionGroups.forEach((group) => {
    const btns = group.querySelectorAll('.pdp-option-btn');
    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const variant = findVariant();
        updateForVariant(variant);
      });
    });
  });
}

/* =====================================================
   PDP: QTY CONTROL
   ===================================================== */
function initQtyControl() {
  const decrementBtns = document.querySelectorAll('.qty-btn--dec');
  const incrementBtns = document.querySelectorAll('.qty-btn--inc');

  decrementBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const val = btn.parentElement.querySelector('.qty-val');
      if (!val) return;
      const current = parseInt(val.value) || 1;
      if (current > 1) val.value = current - 1;
    });
  });

  incrementBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const val = btn.parentElement.querySelector('.qty-val');
      if (!val) return;
      const current = parseInt(val.value) || 1;
      val.value = current + 1;
    });
  });
}

/* =====================================================
   COLLECTION: FILTER SIDEBAR MOBILE
   ===================================================== */
function initCollectionFilters() {
  const filterToggle = document.getElementById('filterToggle');
  const filterDrawer = document.getElementById('filterDrawer');
  const filterClose = document.getElementById('filterClose');

  if (!filterToggle || !filterDrawer) return;

  filterToggle.addEventListener('click', () => {
    filterDrawer.classList.toggle('open');
  });

  if (filterClose) {
    filterClose.addEventListener('click', () => {
      filterDrawer.classList.remove('open');
    });
  }
}

/* =====================================================
   MEGA MENU — keyboard accessibility
   ===================================================== */
function initMegaMenu() {
  const megaItem = document.querySelector('.nav-item--mega');
  if (!megaItem) return;

  const megaMenu = megaItem.querySelector('.mega-menu');
  if (!megaMenu) return;

  // Keep accessible on focus
  megaItem.addEventListener('focusin', () => {
    megaMenu.style.opacity = '1';
    megaMenu.style.visibility = 'visible';
    megaMenu.style.transform = 'translateX(-50%) translateY(0)';
    megaMenu.style.pointerEvents = 'auto';
  });

  megaItem.addEventListener('focusout', (e) => {
    if (!megaItem.contains(e.relatedTarget)) {
      megaMenu.style.opacity = '';
      megaMenu.style.visibility = '';
      megaMenu.style.transform = '';
      megaMenu.style.pointerEvents = '';
    }
  });
}

/* =====================================================
   DYNO BARS — animate on scroll
   ===================================================== */
function initDynoBars() {
  const fills = document.querySelectorAll('.dyno-bar__fill');
  if (!fills.length) return;

  // Store original widths, set to 0 first
  fills.forEach(fill => {
    fill.dataset.target = fill.style.getPropertyValue('--fill') || '0%';
    fill.style.setProperty('--fill', '0%');
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const card = entry.target;
        const cardFills = card.querySelectorAll('.dyno-bar__fill');
        cardFills.forEach(fill => {
          fill.style.setProperty('--fill', fill.dataset.target);
        });
        observer.unobserve(card);
      }
    });
  }, { threshold: 0.4 });

  document.querySelectorAll('.dyno-card').forEach(card => observer.observe(card));
}

/* =====================================================
   SHOPIFY CART — Ajax API integration
   ===================================================== */
function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

async function refreshCart() {
  const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
  try {
    const res = await fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return null;
    const cart = await res.json();
    updateCartCount(cart.item_count);
    return cart;
  } catch (e) {
    return null;
  }
}

function initCart() {
  refreshCart();

  const form = document.querySelector('.pdp-form');
  const addBtn = document.querySelector('.pdp-add-btn');
  if (!form || !addBtn) return;

  const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) || '/cart/add';

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (addBtn.disabled) return;

    const originalText = addBtn.innerHTML;
    addBtn.disabled = true;
    addBtn.textContent = 'ADDING…';

    try {
      const formData = new FormData(form);
      const res = await fetch(cartAddUrl + '.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }

      await refreshCart();
      addBtn.textContent = 'ADDED TO CART ✓';
      addBtn.style.background = '#2a7a2a';
      addBtn.style.borderColor = '#2a7a2a';

      setTimeout(() => {
        addBtn.innerHTML = originalText;
        addBtn.style.background = '';
        addBtn.style.borderColor = '';
        addBtn.disabled = false;
      }, 2500);
    } catch (err) {
      addBtn.textContent = err.message ? err.message.toUpperCase() : 'ERROR';
      addBtn.style.background = 'var(--red)';
      setTimeout(() => {
        addBtn.innerHTML = originalText;
        addBtn.style.background = '';
        addBtn.disabled = false;
      }, 3000);
    }
  });
}

/* =====================================================
   CART PAGE — Inline qty controls
   ===================================================== */
function initCartPageQty() {
  const dec = document.querySelectorAll('.cart-form .qty-btn--dec');
  const inc = document.querySelectorAll('.cart-form .qty-btn--inc');
  dec.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.qty-val');
      if (!input) return;
      const cur = parseInt(input.value) || 1;
      input.value = Math.max(0, cur - 1);
    });
  });
  inc.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.qty-val');
      if (!input) return;
      const cur = parseInt(input.value) || 0;
      input.value = cur + 1;
    });
  });
}

/* =====================================================
   COLLECTION SORT — submit on change
   ===================================================== */
function initCollectionSort() {
  const sortSelect = document.getElementById('sortSelect');
  if (!sortSelect) return;
  sortSelect.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
}

/* =====================================================
   HERO — placeholder so init list always resolves
   ===================================================== */
function initHeroFromData() {
  // No-op; initHeroAnimations now reads data-headline directly.
  // Kept for any future hero-data hooks.
}

/* =====================================================
   INIT
   ===================================================== */
document.addEventListener('DOMContentLoaded', () => {
  initUtilityRotator();
  initNavScroll();
  initMobileMenu();
  initHeroAnimations();
  initScrollReveal();
  initFitmentSelector();
  initDragScroll('.vehicles-carousel');
  initDragScroll('.dyno-carousel');
  initCarouselNav();
  initNewsletter();
  initPdpTabs();
  initPdpGallery();
  initPdpOptions();
  initQtyControl();
  initCollectionFilters();
  initMegaMenu();
  initDynoBars();
  initCart();
  initCartPageQty();
  initCollectionSort();
  initHeroFromData();
});

/* Smooth scroll for anchor links */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    if (href === '#') return;
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

/* =====================================================
   CART DRAWER (slide-in)
   ===================================================== */
function openCartDrawer() {
  const d = document.getElementById('cartDrawer');
  const o = document.getElementById('cartDrawerOverlay');
  if (!d) return;
  d.classList.add('open');
  d.setAttribute('aria-hidden', 'false');
  if (o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCartDrawer() {
  const d = document.getElementById('cartDrawer');
  const o = document.getElementById('cartDrawerOverlay');
  if (!d) return;
  d.classList.remove('open');
  d.setAttribute('aria-hidden', 'true');
  if (o) o.classList.remove('open');
  document.body.style.overflow = '';
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = String(str || '');
  return div.innerHTML;
}

function fmtMoney(cents, currency) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
}

function renderCartItems(cart) {
  if (!cart || cart.item_count === 0) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return '<div class="cart-drawer__empty">' +
      '<p style="font-family: var(--font-display); font-weight: 900; font-size: 24px; letter-spacing: 0.02em; margin-bottom: 16px;">YOUR CART IS EMPTY</p>' +
      '<p style="color: var(--text-secondary); margin-bottom: 24px;">Find your fitment and start your build.</p>' +
      '<a href="' + root + 'collections/all" class="btn btn--black">SHOP NOW →</a></div>';
  }
  const items = cart.items.map((item, i) => {
    const idx = i + 1;
    const imgUrl = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    const img = imgUrl ? '<img src="' + imgUrl + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="80" height="80">' : '';
    const variant = (!item.variant_title || item.variant_title === 'Default Title') ? '' : '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>';
    const vendor = item.vendor ? '<p class="cart-drawer__item-vendor mono-label gold-text">' + escapeHtml(item.vendor.toUpperCase()) + '</p>' : '';
    return '<li class="cart-drawer__item" data-line-item="' + idx + '">' +
      '<a href="' + item.url + '" class="cart-drawer__item-img">' + img + '</a>' +
      '<div class="cart-drawer__item-info">' +
        vendor +
        '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
        variant +
        '<div class="cart-drawer__item-controls">' +
          '<div class="qty-control qty-control--sm">' +
            '<button type="button" class="qty-btn qty-btn--dec" data-line="' + idx + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
            '<span class="qty-val">' + item.quantity + '</span>' +
            '<button type="button" class="qty-btn qty-btn--inc" data-line="' + idx + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' + fmtMoney(item.final_line_price, cart.currency) + '</p>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cart-drawer__item-remove" data-line="' + idx + '" data-qty="0" aria-label="Remove">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button>' +
    '</li>';
  }).join('');
  return '<ul class="cart-drawer__items">' + items + '</ul>';
}

function refreshFreeShippingBar(cart) {
  const bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar) return;
  const threshold = parseInt(bar.dataset.threshold || '0', 10);
  if (!threshold) return;
  const fill = bar.querySelector('[data-shipping-fill]');
  const text = bar.querySelector('[data-shipping-text]');
  const total = (cart && cart.total_price) || 0;
  const pct = Math.min(100, Math.round((total / threshold) * 100));
  if (fill) fill.style.width = pct + '%';
  if (text) {
    if (total >= threshold) {
      text.innerHTML = '<strong>FREE SHIPPING UNLOCKED ✓</strong>';
    } else {
      text.innerHTML = 'Add <strong>' + fmtMoney(threshold - total, cart && cart.currency) + '</strong> for free shipping';
    }
  }
}

async function refreshCartDrawer() {
  const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
  const body = document.querySelector('[data-cart-drawer-body]');
  const subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (!body) return;
  try {
    const res = await fetch(cartUrl + '.js');
    const cart = await res.json();
    updateCartCount(cart.item_count);
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price, cart.currency);
    body.innerHTML = renderCartItems(cart);
    refreshFreeShippingBar(cart);
  } catch (e) { /* silent */ }
}

async function changeCartLine(line, qty) {
  const url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_change_url) || '/cart/change';
  try {
    const res = await fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    });
    if (!res.ok) return;
    const cart = await res.json();
    updateCartCount(cart.item_count);
    const body = document.querySelector('[data-cart-drawer-body]');
    if (body) body.innerHTML = renderCartItems(cart);
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = fmtMoney(cart.total_price, cart.currency);
    refreshFreeShippingBar(cart);
  } catch (e) { /* silent */ }
}

function initCartDrawer() {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  document.querySelectorAll('[data-cart-toggle]').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); openCartDrawer(); });
  });

  document.getElementById('cartDrawerClose')?.addEventListener('click', closeCartDrawer);
  document.getElementById('cartDrawerOverlay')?.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('open')) closeCartDrawer(); });

  drawer.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line][data-qty]');
    if (!btn) return;
    e.preventDefault();
    changeCartLine(btn.dataset.line, btn.dataset.qty);
  });
}

/* =====================================================
   PREDICTIVE SEARCH
   ===================================================== */
function openSearch() {
  const d = document.getElementById('predictiveSearch');
  const o = document.getElementById('predictiveSearchOverlay');
  if (!d) return;
  d.classList.add('open');
  d.setAttribute('aria-hidden', 'false');
  if (o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
  const input = document.getElementById('predictiveSearchInput');
  if (input) setTimeout(() => input.focus(), 50);
}
function closeSearch() {
  const d = document.getElementById('predictiveSearch');
  const o = document.getElementById('predictiveSearchOverlay');
  if (!d) return;
  d.classList.remove('open');
  d.setAttribute('aria-hidden', 'true');
  if (o) o.classList.remove('open');
  document.body.style.overflow = '';
}

let _searchDebounce = null;
async function runPredictiveSearch(q) {
  const resultsEl = document.querySelector('[data-predictive-results]');
  if (!resultsEl) return;
  if (!q || q.length < 2) { resultsEl.innerHTML = ''; return; }
  const url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.predictive_search_url) || '/search/suggest';
  try {
    const res = await fetch(url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8');
    const data = await res.json();
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) {
      resultsEl.innerHTML = '<p style="padding: 24px; color: var(--text-secondary);">No matches for "' + escapeHtml(q) + '".</p>';
      return;
    }
    const html = products.map(p => {
      const img = p.featured_image ? '<img src="' + p.featured_image.url + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="48" height="48">' : '';
      const price = p.price ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(p.price)) : '';
      const vendor = p.vendor ? '<p class="predictive-search__result-vendor mono-label gold-text">' + escapeHtml(p.vendor.toUpperCase()) + '</p>' : '';
      return '<a href="' + p.url + '" class="predictive-search__result">' +
        '<div class="predictive-search__result-img">' + img + '</div>' +
        '<div class="predictive-search__result-info">' +
          vendor +
          '<p class="predictive-search__result-title">' + escapeHtml(p.title) + '</p>' +
          '<p class="predictive-search__result-price">' + price + '</p>' +
        '</div>' +
      '</a>';
    }).join('');
    resultsEl.innerHTML = html;
  } catch (e) { /* silent */ }
}

function initPredictiveSearch() {
  const d = document.getElementById('predictiveSearch');
  if (!d) return;
  document.querySelectorAll('[data-search-toggle]').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); openSearch(); });
  });
  document.getElementById('predictiveSearchClose')?.addEventListener('click', closeSearch);
  document.getElementById('predictiveSearchOverlay')?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && d.classList.contains('open')) closeSearch(); });
  const input = document.getElementById('predictiveSearchInput');
  if (input) {
    input.addEventListener('input', () => {
      clearTimeout(_searchDebounce);
      _searchDebounce = setTimeout(() => runPredictiveSearch(input.value.trim()), 200);
    });
  }
}

/* =====================================================
   ADD-TO-CART INTERCEPT — open drawer if enabled
   ===================================================== */
function initAddToCartIntercept() {
  const form = document.querySelector('.pdp-form');
  const addBtn = document.querySelector('.pdp-add-btn');
  if (!form || !addBtn) return;
  if (!document.getElementById('cartDrawer')) return;

  const cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) || '/cart/add';

  const newForm = form.cloneNode(true);
  form.parentNode.replaceChild(newForm, form);
  const newAddBtn = newForm.querySelector('.pdp-add-btn');

  // Re-init qty + variant logic on cloned form
  newForm.querySelectorAll('.qty-btn--dec').forEach(btn => {
    btn.addEventListener('click', () => {
      const v = btn.parentElement.querySelector('.qty-val');
      if (!v) return;
      v.value = Math.max(1, (parseInt(v.value) || 1) - 1);
    });
  });
  newForm.querySelectorAll('.qty-btn--inc').forEach(btn => {
    btn.addEventListener('click', () => {
      const v = btn.parentElement.querySelector('.qty-val');
      if (!v) return;
      v.value = (parseInt(v.value) || 1) + 1;
    });
  });

  newForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (newAddBtn.disabled) return;
    const originalText = newAddBtn.innerHTML;
    newAddBtn.disabled = true;
    newAddBtn.textContent = 'ADDING…';
    try {
      const res = await fetch(cartAddUrl + '.js', { method: 'POST', body: new FormData(newForm), headers: { 'Accept': 'application/javascript' } });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }
      await refreshCartDrawer();
      openCartDrawer();
      newAddBtn.innerHTML = originalText;
      newAddBtn.disabled = false;
    } catch (err) {
      newAddBtn.textContent = err.message ? err.message.toUpperCase() : 'ERROR';
      newAddBtn.style.background = 'var(--red)';
      setTimeout(() => {
        newAddBtn.innerHTML = originalText;
        newAddBtn.style.background = '';
        newAddBtn.disabled = false;
      }, 3000);
    }
  });
}

/* =====================================================
   PDP IMAGE ZOOM
   ===================================================== */
function initPdpZoom() {
  const main = document.querySelector('.pdp-main-img');
  const img = document.getElementById('pdpMainImg');
  if (!main || !img) return;
  main.style.overflow = 'hidden';
  main.addEventListener('mousemove', (e) => {
    const rect = main.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
    img.style.transform = 'scale(1.6)';
    img.style.transition = 'transform 0.1s';
  });
  main.addEventListener('mouseleave', () => {
    img.style.transform = '';
    img.style.transformOrigin = '';
  });
}

/* =====================================================
   STICKY MOBILE ADD-TO-CART
   ===================================================== */
function initStickyMobileCta() {
  const addBtn = document.querySelector('.pdp-add-btn');
  if (!addBtn) return;
  const sticky = document.createElement('div');
  sticky.className = 'pdp-sticky-cta';
  sticky.innerHTML = '<button type="button" class="btn btn--gold" data-sticky-add>' + (addBtn.textContent || 'ADD TO CART') + '</button>';
  document.body.appendChild(sticky);
  const observer = new IntersectionObserver(([entry]) => {
    sticky.classList.toggle('visible', !entry.isIntersecting);
  }, { rootMargin: '0px 0px -100% 0px' });
  observer.observe(addBtn);
  sticky.querySelector('[data-sticky-add]').addEventListener('click', () => {
    document.querySelector('.pdp-form')?.dispatchEvent(new Event('submit', { cancelable: true }));
  });
}

/* =====================================================
   VEHICLE CONTEXT BAR (cookie-driven)
   ===================================================== */
const SCP_VEHICLE_KEY = 'scp_vehicle';

function getStoredVehicle() {
  try {
    const raw = localStorage.getItem(SCP_VEHICLE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) { return null; }
}

function setStoredVehicle(vehicle) {
  try {
    localStorage.setItem(SCP_VEHICLE_KEY, JSON.stringify(vehicle));
    renderVehicleBar();
  } catch (e) { /* silent */ }
}

function clearStoredVehicle() {
  try {
    localStorage.removeItem(SCP_VEHICLE_KEY);
    renderVehicleBar();
  } catch (e) { /* silent */ }
}

function renderVehicleBar() {
  const bar = document.getElementById('vehicleContextBar');
  if (!bar) return;
  const v = getStoredVehicle();
  if (!v || !v.make) {
    bar.hidden = true;
    document.body.classList.remove('has-vehicle-bar');
    return;
  }
  const name = bar.querySelector('[data-vehicle-name]');
  if (name) {
    const parts = [v.year, v.make, v.model].filter(Boolean).join(' ');
    name.textContent = parts.toUpperCase();
  }
  bar.hidden = false;
  document.body.classList.add('has-vehicle-bar');
}

function initVehicleContextBar() {
  renderVehicleBar();
  const bar = document.getElementById('vehicleContextBar');
  if (!bar) return;

  bar.querySelector('[data-vehicle-clear]')?.addEventListener('click', clearStoredVehicle);
  bar.querySelector('[data-vehicle-change]')?.addEventListener('click', (e) => {
    e.preventDefault();
    const fitment = document.getElementById('fitment');
    if (fitment) {
      fitment.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = '/#fitment';
    }
  });

  // Hook fitment-finder chips/selects to persist
  const make = document.getElementById('makeSelect');
  const model = document.getElementById('modelSelect');
  const year = document.getElementById('yearSelect');
  const persist = () => {
    if (make && make.value) {
      setStoredVehicle({ make: make.value, model: model?.value || '', year: year?.value || '' });
    }
  };
  [make, model, year].forEach(el => el?.addEventListener('change', persist));

  // Quick chips
  document.querySelectorAll('.chip').forEach(chip => {
    chip.addEventListener('click', () => {
      setTimeout(() => {
        setStoredVehicle({
          make: chip.dataset.make || '',
          model: chip.dataset.model || '',
          year: year?.value || ''
        });
      }, 100);
    });
  });
}

/* =====================================================
   RECENTLY VIEWED (cookie-driven)
   ===================================================== */
const SCP_RECENT_KEY = 'scp_recent_products';

function trackRecentlyViewed() {
  if (!document.body.classList.contains('template-product')) return;
  try {
    const productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;
    const product = JSON.parse(productJsonEl.textContent);
    const stored = JSON.parse(localStorage.getItem(SCP_RECENT_KEY) || '[]');
    const filtered = stored.filter(p => p.handle !== product.handle).slice(0, 7);
    filtered.unshift({
      handle: product.handle,
      title: product.title,
      url: '/products/' + product.handle,
      image: product.featured_image,
      price: product.price,
      vendor: product.vendor
    });
    localStorage.setItem(SCP_RECENT_KEY, JSON.stringify(filtered.slice(0, 8)));
  } catch (e) { /* silent */ }
}

function renderRecentlyViewed() {
  const section = document.querySelector('[data-recently-viewed]');
  const grid = document.querySelector('[data-recently-viewed-grid]');
  if (!section || !grid) return;
  try {
    const items = JSON.parse(localStorage.getItem(SCP_RECENT_KEY) || '[]');
    const currentHandle = document.body.classList.contains('template-product') ?
      (JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{}').handle) : null;
    const filtered = items.filter(p => p.handle !== currentHandle).slice(0, 4);
    if (filtered.length === 0) return;
    grid.innerHTML = filtered.map(p => {
      const img = p.image ? '<img src="' + p.image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '<div class="product-card__img-placeholder"></div>';
      const price = typeof p.price === 'number' ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(p.price / 100) : (p.price || '');
      const vendor = p.vendor ? '<p class="product-card__fitment mono-label gold-text">' + escapeHtml(p.vendor.toUpperCase()) + '</p>' : '';
      return '<a href="' + p.url + '" class="product-card">' +
        '<div class="product-card__img-wrap">' + img + '</div>' +
        '<div class="product-card__info">' +
          vendor +
          '<h3 class="product-card__name">' + escapeHtml(p.title) + '</h3>' +
          '<p class="product-card__price">' + price + '</p>' +
        '</div>' +
      '</a>';
    }).join('');
    section.style.display = '';
  } catch (e) { /* silent */ }
}

/* =====================================================
   CART UPSELL — quick-add from rail
   ===================================================== */
function initCartUpsell() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.dataset.upsellAdd;
    if (!id) return;
    const url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) || '/cart/add';
    btn.disabled = true;
    btn.textContent = '…';
    try {
      const res = await fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCartDrawer();
      btn.textContent = '✓';
      setTimeout(() => { btn.textContent = '+'; btn.disabled = false; }, 1200);
    } catch (err) {
      btn.textContent = '!';
      setTimeout(() => { btn.textContent = '+'; btn.disabled = false; }, 1500);
    }
  });
}

/* =====================================================
   QUICK-ADD on product cards (collection + homepage)
   ===================================================== */
function initQuickAddCards() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    const orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    const url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) || '/cart/add';
    try {
      const res = await fetch(url + '.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/javascript' } });
      if (!res.ok) throw new Error('add failed');
      if (document.getElementById('cartDrawer')) {
        await refreshCartDrawer();
        openCartDrawer();
      } else {
        await refreshCart();
      }
      btn.textContent = '✓ Added';
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1500);
    } catch (err) {
      btn.textContent = 'Error';
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
    }
  });
}

/* =====================================================
   ANALYTICS dataLayer events (GA4 + Meta pixel compatible)
   ===================================================== */
function pushDataLayer(event, payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({ event: event }, payload || {}));
}

function trackProductView() {
  if (!document.body.classList.contains('template-product')) return;
  try {
    const product = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{}');
    if (!product.id) return;
    pushDataLayer('view_item', {
      ecommerce: {
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
        value: (product.price || 0) / 100,
        items: [{
          item_id: product.id,
          item_name: product.title,
          item_brand: product.vendor,
          item_category: product.type,
          price: (product.price || 0) / 100
        }]
      }
    });
  } catch (e) { /* silent */ }
}

function trackAddToCart(productId, quantity, price) {
  pushDataLayer('add_to_cart', {
    ecommerce: {
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      value: (price || 0) * (quantity || 1) / 100,
      items: [{ item_id: productId, quantity: quantity || 1, price: (price || 0) / 100 }]
    }
  });
}

function trackSearch(term) {
  if (term && term.length >= 2) pushDataLayer('search', { search_term: term });
}

// Hook tracking into existing functions
const _origRunPredictive = typeof runPredictiveSearch === 'function' ? runPredictiveSearch : null;
if (_origRunPredictive) {
  runPredictiveSearch = function(q) {
    if (q && q.length >= 3) trackSearch(q);
    return _origRunPredictive(q);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initPredictiveSearch();
  initAddToCartIntercept();
  initPdpZoom();
  initStickyMobileCta();
  initVehicleContextBar();
  trackRecentlyViewed();
  renderRecentlyViewed();
  initCartUpsell();
  initQuickAddCards();
  trackProductView();
});

// Listen for cart adds across the site
document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!form.action || !form.action.includes('/cart/add')) return;
  const id = form.querySelector('[name="id"]')?.value;
  const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
  if (id) {
    // Best-effort price from product json on PDP, otherwise 0
    let price = 0;
    try {
      const p = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{}');
      const variant = (p.variants || []).find(v => String(v.id) === String(id));
      price = (variant && variant.price) || p.price || 0;
    } catch (e) {}
    trackAddToCart(id, qty, price);
  }
});

/* ─────────────────────────────────────────────────────────────────
   PRODUCT RECOMMENDATIONS — async via Shopify's /recommendations API
   On every PDP, fetches ML-driven related products (intent=related)
   and renders them via sections/product-recommendations.liquid.
   Replaces the old "first collection" Liquid that surfaced SCP merch
   on every parts page.
───────────────────────────────────────────────────────────────── */
(function initProductRecommendations() {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-recommendations]').forEach(async (block) => {
      const pid = block.dataset.productId;
      const container = block.querySelector('[data-recs-container]');
      if (!pid || !container) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // Request 10 (Shopify max) so the Liquid filter has enough material
      // to discard merch/apparel and still hit the 6-card target.
      const url = `${root}recommendations/products?section_id=product-recommendations&product_id=${pid}&limit=10&intent=related`;

      try {
        const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const html = await res.text();

        const doc = new DOMParser().parseFromString(html, 'text/html');
        // Shopify wraps the section in <div class="shopify-section">…</div>;
        // we want the inner content.
        const sectionEl = doc.querySelector('.shopify-section') || doc.body;
        const rendered = sectionEl ? sectionEl.innerHTML.trim() : '';

        if (!rendered || rendered.indexOf('product-card') === -1) {
          // No recommendations returned — keep the section hidden.
          return;
        }

        container.innerHTML = rendered;
        // .reveal cards start at opacity:0 and only animate in when the page-load
        // IntersectionObserver hits them — these injected ones are never observed,
        // so pre-flag them visible.
        container.querySelectorAll('.reveal').forEach(el => el.classList.add('in-view'));

        block.removeAttribute('hidden');
      } catch (err) {
        console.warn('Recommendations fetch failed:', err);
        // Leave the section hidden — no broken empty block visible to shoppers.
      }
    });
  });
})();

/* ─────────────────────────────────────────────────────────────────
   LOAD MORE — collection + search pages
   Click [data-load-more] → fetch the next paginate URL, parse the
   response's [data-product-grid] children, append them to the
   current grid, and either update the button's next-URL with the
   following page or remove the button when the last page is loaded.
   Works for any page that renders the documented data-* hooks:
     - [data-product-grid]
     - [data-load-more-wrap] containing [data-load-more]
     - [data-results-count] with [data-results-shown] inside (optional)
───────────────────────────────────────────────────────────────── */
(function initLoadMore() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();

    const nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl || btn.classList.contains('is-loading')) return;

    const grid = document.querySelector('[data-product-grid]');
    const wrap = btn.closest('[data-load-more-wrap]');
    if (!grid) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      const res = await fetch(nextUrl, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Append product cards from the next page's grid
      const incomingGrid = doc.querySelector('[data-product-grid]');
      if (incomingGrid) {
        const fragment = document.createDocumentFragment();
        Array.from(incomingGrid.children).forEach(node => {
          // The theme's .reveal class starts at opacity:0 and only becomes
          // visible when an IntersectionObserver (attached at page load) adds
          // .in-view. Dynamically-appended nodes are never observed, so they
          // stay invisible. Pre-flag them as visible.
          if (node.classList && node.classList.contains('reveal')) {
            node.classList.add('in-view');
          }
          node.querySelectorAll && node.querySelectorAll('.reveal').forEach(r => r.classList.add('in-view'));
          fragment.appendChild(node);
        });
        grid.appendChild(fragment);
      }

      // Update results-shown counter if present
      const shownEl = document.querySelector('[data-results-shown]');
      const countEl = document.querySelector('[data-results-count]');
      if (shownEl && countEl) {
        const total = parseInt(countEl.getAttribute('data-total') || '0', 10);
        const newCount = grid.children.length;
        shownEl.textContent = Math.min(newCount, total);
      }

      // Either replace the button with the next-page version, or remove it
      const incomingBtn = doc.querySelector('[data-load-more]');
      if (incomingBtn && incomingBtn.getAttribute('data-next-url')) {
        btn.setAttribute('data-next-url', incomingBtn.getAttribute('data-next-url'));
        btn.classList.remove('is-loading');
        btn.disabled = false;
      } else if (wrap) {
        // No more pages — remove the load-more button entirely
        wrap.remove();
      } else {
        btn.remove();
      }

      // Push a soft URL update (so refreshing keeps user near where they were)
      try { history.replaceState(null, '', nextUrl); } catch (_) {}
    } catch (err) {
      console.error('Load more failed:', err);
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      btn.disabled = false;
      btn.textContent = 'Retry — load more';
      // Clear the error class after a moment so retry click works visually
      setTimeout(() => btn.classList.remove('is-error'), 1500);
    }
  });
})();
